import { render, staticRenderFns } from "./mobileStaticPage.vue?vue&type=template&id=9df8a80e&scoped=true"
import script from "./mobileStaticPage.vue?vue&type=script&lang=js"
export * from "./mobileStaticPage.vue?vue&type=script&lang=js"
import style0 from "./mobileStaticPage.vue?vue&type=style&index=0&id=9df8a80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df8a80e",
  null
  
)

export default component.exports